import { __read } from 'tslib';
import * as React from 'react';
import { dateUtils } from 'uitk-react-calendar';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkDateSelectorInputs } from './uitk-date-selector-inputs.esm.js';
import { UitkDateSelectorAdapter } from './uitk-date-selector-adapter.esm.js';
import './uitk-date-selector.css';
var UitkDateSelector = function (props) {
  var alertTemplateComponent = props.alertTemplateComponent,
    alertTemplateData = props.alertTemplateData,
    _a = props.allowClearDates,
    allowClearDates = _a === void 0 ? true : _a,
    _b = props.autoCloseOnSelection,
    autoCloseOnSelection = _b === void 0 ? false : _b,
    className = props.className,
    clearButtonLabel = props.clearButtonLabel,
    customAriaLabels = props.customAriaLabels,
    dateFormatOptions = props.dateFormatOptions,
    datesInHeaderLabels = props.datesInHeaderLabels,
    dayData = props.dayData,
    dayNameLength = props.dayNameLength,
    dayTemplateComponent = props.dayTemplateComponent,
    _c = props.dialogId,
    dialogId = _c === void 0 ? 'default' : _c,
    enablePastDates = props.enablePastDates,
    enableSameDayDateRange = props.enableSameDayDateRange,
    endDate = props.endDate,
    endDateRef = props.endDateRef,
    calendarWrapper = props.calendarWrapper,
    handleShape = props.handleShape,
    hideDialogSubmit = props.hideDialogSubmit,
    hideFooter = props.hideFooter,
    initialDisplayDate = props.initialDisplayDate,
    _d = props.initialOpenState,
    initialOpenState = _d === void 0 ? false : _d,
    inputIcon1 = props.inputIcon1,
    inputIcon2 = props.inputIcon2,
    inputLabel1 = props.inputLabel1,
    inputLabel2 = props.inputLabel2,
    inputName1 = props.inputName1,
    inputName2 = props.inputName2,
    invalidInput1 = props.invalidInput1,
    invalidInput2 = props.invalidInput2,
    input1Stid = props.input1Stid,
    input2Stid = props.input2Stid,
    _e = props.isSingleDateSelection,
    isSingleDateSelection = _e === void 0 ? false : _e,
    locale = props.locale,
    maxDate = props.maxDate,
    minDate = props.minDate,
    monthLabelAlignment = props.monthLabelAlignment,
    _f = props.navType,
    navType = _f === void 0 ? 'inset' : _f,
    numColumns = props.numColumns,
    numMonthsToAdvance = props.numMonthsToAdvance,
    _g = props.numMonthsToDisplay,
    numMonthsToDisplay = _g === void 0 ? 2 : _g,
    onClose = props.onClose,
    onDateRangeChange = props.onDateRangeChange,
    onDateRangeClear = props.onDateRangeClear,
    onDisabledDayClick = props.onDisabledDayClick,
    onHoverDay = props.onHoverDay,
    onNextClicked = props.onNextClicked,
    onOpen = props.onOpen,
    onPrevClicked = props.onPrevClicked,
    onSelectionModeChange = props.onSelectionModeChange,
    onSubmit = props.onSubmit,
    _h = props.padWeeks,
    padWeeks = _h === void 0 ? false : _h,
    popoverWidth = props.popoverWidth,
    showGridlines = props.showGridlines,
    showMonthLabels = props.showMonthLabels,
    _j = props.showOffset,
    showOffset = _j === void 0 ? false : _j,
    _k = props.showPlayback,
    showPlayback = _k === void 0 ? true : _k,
    showSiblingMonths = props.showSiblingMonths,
    startDate = props.startDate,
    startDateRef = props.startDateRef,
    submitButtonLabel = props.submitButtonLabel,
    trailingText1 = props.trailingText1,
    trailingText2 = props.trailingText2,
    useSingleTrigger = props.useSingleTrigger,
    inputValue1 = props.inputValue1,
    inputValue2 = props.inputValue2,
    displayType = props.displayType,
    isFullSizePlaybackDateDisplay = props.isFullSizePlaybackDateDisplay,
    isNestDialog = props.isNestDialog;
  var DEFAULT_REFERENCE_1 = React.useRef(null);
  var DEFAULT_REFERENCE_2 = React.useRef(null);
  var input1 = startDateRef ? startDateRef : DEFAULT_REFERENCE_1;
  var input2 = endDateRef ? endDateRef : DEFAULT_REFERENCE_2;
  var calendar = React.useRef(null);
  var _l = __read(React.useState(dateUtils.getMonthYear(startDate, initialDisplayDate)), 2),
    monthYear = _l[0],
    setMonthYear = _l[1];
  var _m = __read(React.useState(initialOpenState), 2),
    isOpen = _m[0],
    setIsOpen = _m[1];
  var _o = __read(React.useState('start'), 2),
    selectionChangeMode = _o[0],
    setSelectionChangeMode = _o[1];
  var _p = __read(React.useState(input1), 2),
    triggerRef = _p[0],
    setTriggerRef = _p[1];
  var updateSelectionChangeMode = React.useCallback(function (mode) {
    setSelectionChangeMode(mode);
    onSelectionModeChange && onSelectionModeChange(mode === 'end');
  }, [onSelectionModeChange]);
  var handleOpen = React.useCallback(function (event) {
    var isInput2Selected = (event === null || event === void 0 ? void 0 : event.target) === input2.current;
    var nextTriggerRef = isInput2Selected ? input2 : input1;
    var nextSelectionChangeMode = isInput2Selected && endDate ? 'end' : 'start';
    setMonthYear(dateUtils.getMonthYear(startDate, initialDisplayDate));
    if (isInput2Selected && dateUtils.getMonthYear(startDate).month !== dateUtils.getMonthYear(endDate).month && (numColumns === 2 || numMonthsToDisplay === 2)) {
      setMonthYear({
        month: dateUtils.getMonthYear(endDate).month === 0 ? 11 : dateUtils.getMonthYear(endDate).month -= 1,
        year: dateUtils.getMonthYear(endDate).month === 0 ? dateUtils.getMonthYear(endDate).year -= 1 : dateUtils.getMonthYear(endDate).year
      });
    } else if (isInput2Selected && numMonthsToDisplay === 1) {
      setMonthYear(dateUtils.getMonthYear(endDate, initialDisplayDate));
    }
    setIsOpen(true);
    setTriggerRef(nextTriggerRef);
    if (selectionChangeMode !== nextSelectionChangeMode) {
      updateSelectionChangeMode(nextSelectionChangeMode);
    }
    onOpen && onOpen();
  }, [endDate, initialDisplayDate, input1, input2, numColumns, numMonthsToDisplay, onOpen, selectionChangeMode, startDate, updateSelectionChangeMode]);
  var handleClearDates = React.useCallback(function () {
    updateSelectionChangeMode('start');
    onDateRangeChange && onDateRangeChange(null, null);
    onDateRangeClear && onDateRangeClear();
  }, [onDateRangeChange, onDateRangeClear, updateSelectionChangeMode]);
  var handleClose = React.useCallback(function (shouldClear) {
    updateSelectionChangeMode('start');
    setIsOpen(false);
    // Clear dates when selection not finished
    if (shouldClear && startDate && !(isSingleDateSelection || endDate)) {
      handleClearDates();
    }
    onClose && onClose();
  }, [endDate, handleClearDates, isSingleDateSelection, onClose, startDate, updateSelectionChangeMode]);
  var handleDateChange = function (newStartDate, newEndDate) {
    var shouldAutoClose = autoCloseOnSelection && newStartDate && (newEndDate || isSingleDateSelection);
    onDateRangeChange && onDateRangeChange(newStartDate, newEndDate);
    if (shouldAutoClose) {
      onSubmit && onSubmit(newStartDate, newEndDate);
      handleClose();
    } else if (newEndDate || isSingleDateSelection) {
      updateSelectionChangeMode('start');
    } else {
      updateSelectionChangeMode('end');
    }
  };
  // Although uitk-react-calendar can receive any number for numMonthsToDisplay
  // we have a business rule that will only allow the date selector to pass 1 or 2.
  var numberOfMonthsToDisplay = React.useMemo(function () {
    return numMonthsToDisplay === 1 ? numMonthsToDisplay : 2;
  }, [numMonthsToDisplay]);
  var shouldHideDialogSubmitButton = React.useMemo(function () {
    return hideDialogSubmit && !(!autoCloseOnSelection && startDate && (endDate || isSingleDateSelection));
  }, [autoCloseOnSelection, endDate, hideDialogSubmit, isSingleDateSelection, startDate]);
  return React.createElement(UitkLayoutPosition, {
    type: "relative"
  }, displayType !== 'composable' && React.createElement(UitkDateSelectorInputs, {
    dateFormatOptions: dateFormatOptions,
    dialogId: dialogId,
    endDate: endDate,
    handleClickInput1: handleOpen,
    handleClickInput2: handleOpen,
    input1Ref: input1,
    input2Ref: input2,
    inputIcon1: inputIcon1,
    inputIcon2: inputIcon2,
    inputLabel1: inputLabel1,
    inputLabel2: inputLabel2,
    inputName1: inputName1,
    inputName2: inputName2,
    invalidInput1: invalidInput1,
    invalidInput2: invalidInput2,
    input1Stid: input1Stid,
    input2Stid: input2Stid,
    isSingleDateSelection: isSingleDateSelection,
    locale: locale,
    startDate: startDate,
    inputValue1: inputValue1,
    inputValue2: inputValue2,
    trailingText1: trailingText1,
    trailingText2: trailingText2,
    useSingleTrigger: useSingleTrigger
  }), React.createElement(UitkDateSelectorAdapter, {
    alertTemplateComponent: alertTemplateComponent,
    alertTemplateData: alertTemplateData,
    allowClearDates: allowClearDates,
    calendarRef: calendar,
    className: className,
    clearButtonLabel: clearButtonLabel,
    calendarWrapper: calendarWrapper,
    customAriaLabels: customAriaLabels,
    datesInHeaderLabels: datesInHeaderLabels,
    dayData: dayData,
    dayNameLength: dayNameLength,
    dayTemplateComponent: dayTemplateComponent,
    dialogId: dialogId,
    displayType: displayType,
    enablePastDates: enablePastDates,
    enableSameDayDateRange: enableSameDayDateRange,
    endDate: endDate,
    handleShape: handleShape,
    hideFooter: hideFooter,
    hideDialogSubmit: shouldHideDialogSubmitButton,
    isFullSizePlaybackDateDisplay: isFullSizePlaybackDateDisplay,
    isOpen: isOpen,
    isSingleDateSelection: isSingleDateSelection,
    locale: locale,
    maxDate: maxDate,
    minDate: minDate,
    month: monthYear.month,
    monthLabelAlignment: monthLabelAlignment,
    navType: navType,
    numColumns: numColumns,
    numMonthsToAdvance: numMonthsToAdvance,
    numMonthsToDisplay: numberOfMonthsToDisplay,
    onClose: handleClose,
    onDatesCleared: handleClearDates,
    onDisabledDayClick: onDisabledDayClick,
    onHoverDay: onHoverDay,
    onNextClicked: onNextClicked,
    onPrevClicked: onPrevClicked,
    onSelectionChanged: handleDateChange,
    onSubmit: onSubmit,
    padWeeks: padWeeks,
    popoverWidth: popoverWidth,
    selectionChangeMode: selectionChangeMode,
    showGridlines: showGridlines,
    showMonthLabels: showMonthLabels,
    showOffset: showOffset,
    showPlayback: showPlayback,
    showSiblingMonths: showSiblingMonths,
    startDate: startDate,
    submitButtonLabel: submitButtonLabel,
    triggerRef: triggerRef,
    updateSelectionChangeMode: updateSelectionChangeMode,
    year: monthYear.year,
    isNestDialog: isNestDialog
  }));
};
UitkDateSelector.displayName = 'UitkDateSelector';
export { UitkDateSelector };